import MovieFileIcon from '@/../wwwroot/images/icons/movie-file.svg?react';
import FileIcon from '@/../wwwroot/images/icons/file.svg?react';
import FileErrorIcon from '@/../wwwroot/images/icons/file-error.svg?react';
import React from 'react';
import { FileEntity } from '@/hooks/upload-files/types';
import { getFileExtension } from '@/hooks/upload-files/getFileExtension';

const IconPositioner = ({
    children,
    href,
}: React.PropsWithChildren<{ href?: string }>) => {
    if (href) {
        return (
            <a
                href={href}
                target="blank"
                className="flex h-20 w-20 items-center justify-center rounded-lg bg-grey-300"
            >
                {children}
            </a>
        );
    }

    return (
        <div className="flex h-20 w-20 items-center justify-center rounded-lg bg-grey-300">
            {children}
        </div>
    );
};

export const FilePreview = ({ fileEntity }: { fileEntity: FileEntity }) => {
    const extension = getFileExtension(fileEntity.fileName);

    if (fileEntity.isFailed) {
        return (
            <IconPositioner>
                <FileErrorIcon className="h-10 w-10 text-action-red-dark" />
            </IconPositioner>
        );
    }

    const linkToFile = `${window.location.origin}/api/files/${fileEntity.guid}`;

    switch (extension) {
        case 'jpg':
        case 'png':
        case 'jpeg':
            try {
                return (
                    <IconPositioner href={linkToFile}>
                        <img
                            className="h-20 w-20 rounded-lg bg-white object-scale-down"
                            src={
                                fileEntity.file?.size > 0
                                    ? URL.createObjectURL(fileEntity.file)
                                    : linkToFile
                            }
                            alt={fileEntity.fileName}
                        />
                    </IconPositioner>
                );
            } catch (e) {
                return (
                    <IconPositioner href={linkToFile}>
                        <FileIcon className="h-10 w-10" />
                    </IconPositioner>
                );
            }
        case 'gif':
        case 'mov':
            return (
                <IconPositioner href={linkToFile}>
                    <MovieFileIcon className="h-10 w-10" />
                </IconPositioner>
            );
        default:
            return (
                <IconPositioner href={linkToFile}>
                    <FileIcon className="h-10 w-10" />
                </IconPositioner>
            );
    }
};
